import { useEffect, useState } from "react";
import api, { fmtDate } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { NSelect } from "@/components/technique/fields";

function Thumb({ p, onOpen }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    let u = "";
    api.get(`/technique/entries/${p.kind}/${p.entry_id}/photos/${p.id}`, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [p]);
  return (
    <figure className="rounded-lg border bg-white overflow-hidden" data-testid={`gallery-${p.id}`}>
      <div className="aspect-square bg-slate-100 flex items-center justify-center">
        {url ? <img src={url} alt="" className="h-full w-full object-cover cursor-zoom-in" onClick={() => onOpen(url)} /> : <Loader2 className="h-4 w-4 animate-spin text-slate-400" />}
      </div>
      <figcaption className="px-2 py-1.5 text-[11px] leading-tight"><b>{p.kind_label}</b>{p.tag ? ` · ${p.tag}` : ""}<br /><span className="text-slate-500">{p.entry_label} · {fmtDate(p.at)}</span></figcaption>
    </figure>
  );
}

export default function TechPhotos({ fid, refreshKey }) {
  const [list, setList] = useState(null);
  const [kind, setKind] = useState("");
  const [zoom, setZoom] = useState("");
  useEffect(() => { api.get(`/technique/files/${fid}/photos`).then((r) => setList(r.data)); }, [fid, refreshKey]);
  if (!list) return <p className="text-sm text-slate-400">Chargement…</p>;
  const kinds = [...new Set(list.map((p) => p.kind_label))];
  const shown = list.filter((p) => !kind || p.kind_label === kind);
  return (
    <div className="space-y-3" data-testid="tech-photos">
      <div className="flex items-center gap-3"><div className="w-48"><NSelect value={kind} onChange={setKind} placeholder="Toutes les rubriques" options={kinds} testid="gallery-filter" /></div><span className="text-xs text-slate-500">{shown.length} photo(s)</span></div>
      {shown.length === 0 ? <p className="text-sm text-slate-400 rounded-lg border border-dashed p-6 text-center">Aucune photo. Ajoutez-en depuis le journal, les incidents ou les réserves.</p> : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">{shown.map((p) => <Thumb key={p.id} p={p} onOpen={setZoom} />)}</div>
      )}
      {zoom && <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4" onClick={() => setZoom("")}><img src={zoom} alt="" className="max-h-full max-w-full rounded-lg" /></div>}
    </div>
  );
}
